/**
 * @generated SignedSource<<66267d0fc51c7b560aa54fc8570181b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TrackerFilterByIdsQuery$variables = {
  smartTrackerIds: ReadonlyArray<string>;
};
export type TrackerFilterByIdsQuery$data = {
  readonly smartTrackersById: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type TrackerFilterByIdsQuery = {
  response: TrackerFilterByIdsQuery$data;
  variables: TrackerFilterByIdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "smartTrackerIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "smartTrackerIds",
        "variableName": "smartTrackerIds"
      }
    ],
    "concreteType": "SmartTracker",
    "kind": "LinkedField",
    "name": "smartTrackersById",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrackerFilterByIdsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrackerFilterByIdsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b3dbeafd5f3f88ea7b8457f7fe220ad",
    "id": null,
    "metadata": {},
    "name": "TrackerFilterByIdsQuery",
    "operationKind": "query",
    "text": "query TrackerFilterByIdsQuery(\n  $smartTrackerIds: [ID!]!\n) {\n  smartTrackersById(smartTrackerIds: $smartTrackerIds) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc8f9c63cbc6a4e84861cc1d9aec2336";

export default node;
